export const ERR_POPUP_INVALID_PARAMS = 'ERR_POPUP_INVALID_PARAMS';
export const ERR_INVALID_HOSTNAME = 'ERR_INVALID_HOSTNAME';
export const ERR_INVALID_SLUG = 'ERR_INVALID_SLUG';
export const ERR_DATA_INVALID_SIZE = 'ERR_DATA_INVALID_SIZE';
export const ERR_ACCESS_DENIED = 'ERR_ACCESS_DENIED';
export const ERR_ALREADY_CALLED = 'ERR_ALREADY_CALLED';
export const ERR_NOT_AVAILABLE = 'ERR_NOT_AVAILABLE';
